"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transaction = void 0;
const axios_class_1 = require("./axios.class");
class Transaction {
    async getTransactions({ filter = 'all', perPage = 10, currentPage = 0, clientId, signal }) {
        const { data } = await axios_class_1.axios.post(`/transactions/${perPage}/${currentPage}/${filter}`, {
            filters: {
                clientId
            }
        }, { signal });
        return data;
    }
    getSentTransactions(perPage = 10, currentPage = 0) {
        return this.getTransactions({ filter: 'sent', perPage, currentPage });
    }
    getReceivedTransactions(perPage = 10, currentPage = 0) {
        return this.getTransactions({ filter: 'received', perPage, currentPage });
    }
    async requestCode(action) {
        const { data } = await axios_class_1.axios.post(`/transactions/requestCode`, { action });
        return data;
    }
    async sendToPhone(phone, productsIds) {
        try {
            await axios_class_1.axios.post('/transactions/sendToPhone', {
                phoneTo: phone,
                productsIds
            });
            return true;
        }
        catch (_a) {
            return false;
        }
    }
    async sendToEmail(email, productsIds) {
        try {
            await axios_class_1.axios.post('/transactions/sendToEmail', {
                emailTo: email,
                productsIds
            });
            return true;
        }
        catch (_a) {
            return false;
        }
    }
    async sendToAddress(address, productsIds) {
        try {
            await axios_class_1.axios.post('/transactions/sendToAddress', {
                addressTo: address,
                productsIds
            });
            return true;
        }
        catch (_a) {
            return false;
        }
    }
}
exports.transaction = new Transaction();
